<template>
  <Modal :id="id" :dialog-class="dialogClass">
    <div slot="header" class="modal-header">
      <h3 class="modal-title font-weight-bold text-dark">Help Resources</h3>
      <a
        class="contact-link link-with-icon teal-link ga-event"
        href="#"
        @click.prevent="showContactModal()"
        title="Questions or Comments? Send us your feedback"
        data-ga-category="Buttons"
        data-ga-action="feedback-form"
        data-ga-label="Feedback Form"
      >
        <icon icon="mail" class="icon" />
        <span class="text d-none d-md-inline">Contact Us</span>
      </a>
      <a
        class="icon icon-remove text-right text-dark"
        @click.prevent="close()"
        data-dismiss="modal"
        aria-label="Close"
      ></a>
    </div>
    <div slot="body" class="modal-body modal-form">
      <div class="row">
        <div
          v-if="hasContent"
          class="help-content col-12 mb-4 col-lg-7 mb-lg-0"
          v-html="content"
        ></div>
        <div class="help-downloads col-12" :class="{ 'col-lg-5': hasContent }">
          <a
            v-for="(item, i) in downloads"
            :key="i"
            class="link-with-icon teal-link download mb-3"
            :href="item.asset.url"
            target="_blank"
          >
            <icon icon="download" class="icon" />
            <span class="text">{{ item.title }}</span>
          </a>
        </div>
      </div>
    </div>
    <div slot="footer"></div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
import ContactModal from "./ContactModal";
export default {
  mixins: [ModalMixin],
  components: { ContactModal },
  data() {
    return {
      id: "help-modal",
      view: this.$root.view,
      content: "",
      downloads: [],
    };
  },
  computed: {
    hasContent() {
      return this.content.length > 0;
    },
    dialogClass() {
      var classes = [];
      if (this.hasContent) {
        classes.push("has-content");
      }
      return classes.join(" ");
    },
  },
  methods: {
    load() {
      this.axios
        .get(this.route("help"), {
          params: {
            view: this.view,
          },
        })
        .then((response) => {
          this.content = response.data.content;
          this.downloads = response.data.downloads;
        })
        .catch(() => {});
    },
    showContactModal() {
      this.$modal(ContactModal)
        .then(() => {
          this.close();
        })
        .catch(() => {
          this.close();
        });
    },
  },
  mounted() {
    if (_.has(this.options, "view")) {
      this.view = this.options.view;
    }
    this.load();
  },
};
</script>
